import { SubscriptionProvider } from "@/contexts/SubscriptionContext";
import { SubscriptionGuard } from "./SubscriptionGuard";
import { AppLayout } from "./AppLayout";
import { SeoHead } from "@/components/seo/SeoHead";

/**
 * Bootstrap order: auth (SubscriptionGuard) → AppLayout (workspace, subscription, permissions, unread).
 * SubscriptionGuard blocks only on auth + terms; layout and subscription load in parallel after that.
 * SEO: todas as rotas protegidas (dashboard, leads, etc.) recebem noindex.
 */
export function ProtectedLayout() {
  return (
    <SubscriptionProvider>
      <SeoHead
        title="Painel FabChat (requer login)"
        description="Área logada da FabChat — CRM, conversas e configurações. Conteúdo disponível apenas após autenticação."
        noindex
      />
      <SubscriptionGuard>
        <AppLayout />
      </SubscriptionGuard>
    </SubscriptionProvider>
  );
}
